export const CountryCode = {
    DE: 'DE',
    PL: 'PL',
    HU: 'HU',
    RO: 'RO'
} as const;

export type CountryCodeValue = keyof typeof CountryCode;

export type CountryCodeKeys = (typeof CountryCode)[CountryCodeValue];
